module.exports = __webpack_public_path__ + "img/pro17.268c6764.png";